import script from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsPitch.vue?vue&type=style&index=0&id=4a770c47&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a770c47"]])

export default __exports__